import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { fetchTransientStateFromWorkflow } from '../../api/portalGateway/fetchTransientStateFromWorkflow';
import { prependRoleId } from '../../utils/prependRoleId';

export const useTransientWorkflowStatePolling = (
  contentId: string,
  rowIdsToCheck: string[],
  refetchInterval: number,
  nonTransientRowsFound: (rowIds: string[]) => void
) => {
  const { data } = useQuery({
    queryKey: prependRoleId([
      'transientWorkflowState',
      { contentId },
      { rowIds: rowIdsToCheck },
    ]),
    queryFn: fetchTransientStateFromWorkflow,
    refetchInterval,
    enabled: rowIdsToCheck.length > 0,
  });

  useEffect(() => {
    if (data?.status === 'success') {
      const nonTransientRows = data.data.results
        .filter((r) => !r.isTransient)
        .map((r) => r.rowId);
      if (nonTransientRows.length > 0) {
        nonTransientRowsFound(nonTransientRows);
      }
    }
  }, [data, nonTransientRowsFound]);
};
